<template>
  <div style="position: relative; margin-bottom: 15px" v-if="citizenslist">
    <h3 class="clist-title">
      Müraciət edən şəxs ({{citizenslist.length}}nəfər)
    </h3>

    <div
  
      class="cit-list"
    >
      <div
        v-for="(citizen, index) in citizenslist"
        :key="'appeal' + index"
        :class="{
          hoverable: selectable,
          selected: selected && selected.uuid === citizen.uuid,
          'cit-item': true,
        }"
        @click="handleSelect(citizen)"
      >
        <div class="citizen-info-panel">
          <p>
            <b>S.A.A:</b> {{ citizen.lastName }} {{ citizen.firstName }}
            {{ citizen.fatherName }}
          </p>

          <p v-if="citizen.mobilePhoneNumber">
            <span>Əlaqə nömrəsi:</span>
            <span v-if="citizen.mobilePhoneNumber">
              {{ citizen.mobilePhoneNumber }}
            </span>

            <span v-if="citizen.homePhoneNumber">
              {{ "," + citizen.homePhoneNumber }}
            </span>

            <span v-if="citizen.whatsapNumber">
              <img
                src="../../../assets/imgs/whatsapp.png"
                style="width: 24px; vertical-align: middle"
              />
              {{ "," + citizen.whatsapNumber }}
            </span>
          </p>

          <p v-if="citizen.address"><b>Ünvanı :</b> {{ citizen.address }}</p>

          <!-- <p v-if="citizen.text" style="max-width: 800px;">
            <b>Şikayət mətni :</b>

            <span>
              {{ appeal.text.substring(0, 210) }}

              <a-tooltip
                :title="appeal.text"
                v-if="appeal.text.length > 210"
                :overlayStyle="{ maxWidth: '500px' }"
              >
                <a-icon class="more-icon" type="small-dash" />
              </a-tooltip>
            </span>
          </p> -->

          <!--   <p v-if="appeal.dateStr">
            <b>Şikayət tarixi :</b> {{ appeal.dateStr }}
          </p> -->

          <!--  <div v-if="rdOffice">
            <a-button
              class="action"
              type="danger"
              v-if="
                rdOffice.citCanAssest &&
                  type === 'ASSESTMENT' &&
                  appeal.canAssest
              "
              @click="openAssestmentModal(appeal)"
            >
              Rəy al
            </a-button>

            <div
              v-else-if="appeal.currentAssestment && !appeal.canAssest"
              class="assestment-info"
            >
              <p style="margin-bottom: 5px;">
                {{ appeal.currentAssestment.status.name }}
              </p>

              <p style="margin-bottom: 5px;">
                <span v-if="appeal.currentAssestment.startAgain != null">
                  {{
                    appeal.currentAssestment.startAgain
                      ? "Yenidən başlasın"
                      : "Yenidən başlamasın"
                  }}
                </span>

                <a-tooltip
                  v-if="appeal.currentAssestment.note"
                  :title="appeal.currentAssestment.note"
                >
                  <a-icon type="message" style="font-size: 17px;" />
                </a-tooltip>
              </p>

              <div v-if="appeal.currentAssestment.files">
                <a-button
                  v-if="appeal.currentAssestment.files.length > 0"
                  @click="showAssestmentFiles(appeal.currentAssestment)"
                  style="background:purple;color:white;"
                  size="small"
                  >Media fayllara bax</a-button
                >
              </div>
            </div>
          </div> -->

        <div   v-if="citizen.appeals[0].citizenJoined" style=" top:2px;  " class="tag__custom">
          <a-tag color="green">
             Vətəndaş qoşulub
          </a-tag>


<!-- "citizenJoined": false,
    "operatorJoined": false -->
        </div>
             <div v-if="citizen.appeals[0].operatorJoined"   :class="citizen.appeals[0].citizenJoined?'top__px tag__custom':' top__without_px tag__custom'">

                 <a-tag color="orange">
                  Məsul şəxs birləşdirib
                </a-tag>
<!-- "citizenJoined": false,
    "operatorJoined": false -->
        </div>
        <div  @click="handleSelect(citizen)" style="text-align:right; ">
          <a-tag color="#108ee9">
       Ətraflı
      </a-tag>
        </div>

        </div>
      </div>
    </div>

    <!--Assestment dialog-->
    <assestment-modal
      :visible="assestmentModalVis"
      @save="save"
      :selectedDOffice="rdOffice"
      :appeal="selectedAppeal"
      @afterClose="afterAssestmentModalClose"
    />
    <!--media dialog-->
    <a-modal
      title="Müraciətə əlavə olunmuş fayllar"
      v-model="mediadialogVisibility"
      :footer="null"
      :width="980"
      centered
    >
      <conditional-media :filesList="files"></conditional-media>
    </a-modal>
  </div>
</template>

<script>
import { URL, apiCall } from "@/utils/api";
import AssestmentModal from "@/components/pages/Modals/AssestmentModal/index";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";

export default {
  name: "CitizenList",
  props: {
    citizenslist: Array,
    type: String,
    rdOffice: Object,
    compStyle: Object,
    selectable: Boolean,
  },
  components: {
    "assestment-modal": AssestmentModal,
    "conditional-media": ConditionalMedia,
  },
  data() {
    return {
      citizens: [],
      assestmentModalVis: false,
      selectedAppeal: null,
      mediadialogVisibility: false,
      files: [],
      selected: null,
    };
  },
  watch: {
    citizenslist: function (newVal, oldVal) {},
  },
  methods: {
    handleApproveClick(appeal, ans) {
      if (!appeal) return;
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "appeals/" + appeal.id,
        method: "PUT",
        data: { appeal: appeal, answer: ans },
      })
        .then((response) => {
          if (!response.data.error) {
            appeal.isApproved = ans;
            if (!ans) {
              this.citizenslist = this.citizenslist.filter(
                (item) => item.isApproved
              );
            }
          }
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          console.log(err);
        });
    },
    handleSelect(appeal) {
      this.selected = appeal;
      this.$emit("changeSelected", appeal);
    },
    openAssestmentModal(appeal) {
      this.selectedAppeal = appeal;
      this.assestmentModalVis = true;
    },
    afterAssestmentModalClose() {
      this.selectedAppeal = null;
      this.assestmentModalVis = false;
    },
    save() {
      this.selectedAppeal.canAssest = false;
      this.assestmentModalVis = false;
      this.$emit("assested");
      this.checkForAllAssested();
    },
    checkForAllAssested() {
      let allAssested = true;
      for (let index = 0; index < this.citizenslist.length; index++) {
        if (this.citizenslist[index].canAssest) {
          allAssested = false;
          break;
        }
      }
      this.rdOffice.citCanAssest = !allAssested;
    },
    showAssestmentFiles(assestment) {
      this.files = assestment.files;
      if (!this.files || this.files.length === 0) {
        this.$message.warning("Media fayl yoxdur");
        return;
      }
      this.mediadialogVisibility = true;
    },
    fillCurAssestment() {
      this.citizens = this.citizenslist;
      if (this.citizens && this.rdOffice) {
        this.citizens.forEach((item) => {
          if (item.assestments && item.assestments.length > 0) {
            item.currentAssestment = item.assestments.find(
              (el) => el.officeDetail.id === this.rdOffice.id
            );
          }
        });
      }
    },
  },
  created() {
    this.handleSelect(this.citizenslist[0]);
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
